interface Timeout {
  reset(): void;

  clear(): void;
}

export function startTimeout(callback: () => void, ms: number): Timeout {
  let timeout: NodeJS.Timeout | undefined;

  function reset() {
    clear();
    timeout = setTimeout(() => {
      timeout = undefined;
      callback();
    }, ms);
  }

  function clear() {
    if (timeout != null) clearTimeout(timeout);
    timeout = undefined;
  }

  return { reset, clear };
}
